import { render, staticRenderFns } from "./ChatReport.vue?vue&type=template&id=8d64cde8"
import script from "./ChatReport.vue?vue&type=script&lang=js"
export * from "./ChatReport.vue?vue&type=script&lang=js"
import style0 from "./ChatReport.vue?vue&type=style&index=0&id=8d64cde8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports